import api from "@/lib/axios";

const endpoint = "/dashboard/fields";

const formLabelService = {
 
    getPersonalInfoForm: async (companyId = null) => {
        try {
          // If no companyId is provided, return empty structure instead of making API call
          if (!companyId) {
            return {
              dashboard_fields: []
            };
          }
          
          const url = `${endpoint}/${companyId}`;
          const response = await api.get(url);
          return response.data;
        } catch (error) {
          throw new Error("Failed to fetch personal info form: " + error.message);
        }
      },

  createFields: async (companyId,fieldsData) => {
    try {
      const response = await api.post(`${endpoint}/${companyId}`, fieldsData);
      return response.data;
    } catch (error) {
      throw new Error("Failed to create fields: " + error.message);
    }
  },

  updateFields: async (companyId, fieldsData) => {
    try {
      const response = await api.put(`${endpoint}/${companyId}`, fieldsData);
      return response.data;
    } catch (error) {
      throw new Error("Failed to update fields: " + error.message);
    }
  },

};
export default formLabelService;